import { ShopifyStorefrontClient } from '../api/shopify/ShopifyStorefrontClient';

export const skuRedirect = async () => {
  const { pathname, search } = window.location;

  const sku = pathname.split('/').pop();

  if (!sku) {
    console.error(`No sku found in URL: redirecting to homepage`);
    window.location.assign(`/`);
    return;
  }
  const storefrontClient = new ShopifyStorefrontClient();
  const result = await storefrontClient.getProductHandlesBySku([sku]);

  const products = result?.data?.products;

  if (!products?.length || !products[0].handle) {
    console.error(`Product for ${sku} not found: redirecting to homepage`);
    window.location.assign(`/`);
    return;
  }

  const destinationUrl = `/products/${products[0].handle}${search}`;
  window.location.assign(destinationUrl);
};
